export default __webpack_public_path__ + "static/media/teaser_8s_1kbr.d967fedf.mp4";